export default "__VITE_ASSET__DqljAJ6b__"